<div class="graphic_container" id="graphic_container_id">
  <div class="wrapper">
    <div class="inner nr1">
      <img
        class="mockup"
        [ngSrc]="insuranceSymbol"
        width="365"
        height="500"
        loading="lazy"
        alt="platform-online-arbejds-opgave-platform"
      />
    </div>
    <div class="inner nr2">
      <div class="header_div">
        <h2 class="title">
          {{ 'PAGES.DAMAGE_COMPENSATION.HEAD1' | translate }}
        </h2>
        <p>{{ 'PAGES.DAMAGE_COMPENSATION.USP1' | translate }}</p>
      </div>

      <div>
        <div class="usp_wrapper">
          <mat-icon>security</mat-icon>
          <div class="head_wrapper">
            <p class="usp_head">
              {{ 'PAGES.DAMAGE_COMPENSATION.HEAD2' | translate }}
            </p>
            <p>
              {{ 'PAGES.DAMAGE_COMPENSATION.USP2' | translate }}
            </p>
          </div>
        </div>

        <div class="usp_wrapper">
          <mat-icon> person_pin</mat-icon>
          <div class="head_wrapper">
            <p class="usp_head">
              {{ 'PAGES.DAMAGE_COMPENSATION.HEAD3' | translate }}
            </p>
            <p>{{ 'PAGES.DAMAGE_COMPENSATION.USP3' | translate }}</p>
          </div>
        </div>

        <div class="button_div">
          <button (click)="goToInsurancePage()" class="more_info_button">
            {{ 'GENERAL.READ' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
